import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { historyArticles } from "../data/historyArticles";
import HistorySidebar from "../components/history/HistorySidebar";
import HistoryMobileSelector from "../components/history/HistoryMobileSelector";
import HistoryArticle from "../components/history/HistoryArticle";

function History() {
  const { t } = useTranslation();
  const { slug } = useParams();

  const article = slug
    ? historyArticles.find((item) => item.slug === slug)
    : null;

  return (
    <div className="article-section">
      <div className="article-navigator">
        {/* Desktop */}
        <HistorySidebar articles={historyArticles} activeSlug={article?.slug} />

        <main className="min-w-0 flex-1">
          <div className="p-6 sm:p-8 lg:p-10">
            {/* Mobile */}
            <HistoryMobileSelector
              articles={historyArticles}
              activeSlug={article?.slug}
            />

            {article ? (
              <HistoryArticle article={article} />
            ) : (
              <div className="items-center justify-center text-center">
                <div>
                  <p className="base-subtitle">{t("articles.subtitle")}</p>
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default History;
